import TimeTrackerItem from 'Pages/TimeTracker/Components/TimeTrackerItem'
import NoData from 'Organisms/NoData'

const ListTimeTicket = ({ timeEntriesPerDay, onOpenEdit, onRunTime }) => {
  return (
      <div className="card listTimeTicket">
        {timeEntriesPerDay.length === 0 && (
          <div className="listTimeTicket_empty">
            <NoData />
          </div>
        )}

        {timeEntriesPerDay.map((timeEntry) => (
          <TimeTrackerItem key={timeEntry.id} timeEntry={timeEntry} onOpenEdit={onOpenEdit} onRunTime={onRunTime} />
        ))}
      </div>
  )
}

export default ListTimeTicket
